import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpMethod } from 'src/constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  newPassword: any = "";
  confirmPassword: any = "";
  showNewPassword = false;
  showConfirmPassword = false;
  token: any;
  isUser: any = false;
  constructor(public serviceManager: ServiceManagerService, public router: Router, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      if(params["is_user"]){
        this.isUser = true
      }
    });
  }

  ngOnInit(): void {
  }

  resetPassword(){
    var body = {
      "action": "forgot-password",
      "new_password": this.newPassword,
      "confirm_password": this.confirmPassword
    }
    let url = `reset-password?token=${this.token}`
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI(url, body, HttpMethod.POST, customOptions, false).subscribe( (data: any)=>{
      if(data){
        if(!this.isUser){
          this.router.navigate(['/login'])
        }
        else{
          this.newPassword = "";
          this.confirmPassword = "";
        }
      }
    })
  }
}
